import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// "-04:00" → -240 ; "+05:30" → 330 ; formato inválido/IANA/vacío → 0.
export function offsetToMinutes(offset: string): number {
    const m = /^([+-])(\d{2}):(\d{2})$/.exec(offset);
    if (!m) {
        return 0;
    }
    const sign = m[1] === '-' ? -1 : 1;
    return sign * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
}

// Offset del dispositivo en el mismo formato que manda el backend, para poder
// compararlos y para usarlo de fallback cuando el sitio no trae huso.
export function deviceOffset(): string {
    return dayjs().format('Z');
}

// Convierte un instante absoluto al wall-clock del sitio, truncado a la hora.
export function instantToWallClock(instant: dayjs.Dayjs, offset: string): { date: string; time: string } {
    const local = instant.utcOffset(offsetToMinutes(offset));
    return { date: local.format('YYYY-MM-DD'), time: local.format('HH:00:00') };
}
